function truncateString(string:string){
        if(!string) return ' '
        const length = string?.length
        const part = Math.floor(length/7)
        return string?.slice(0,part) +"...."+string?.slice(part*6,length)
}

export default truncateString